import React from 'react'

import { PktButton, PktLink } from '../components'
import { PktHeaderService,Representing, User, UserMenuItem } from '../components/header/HeaderService'

export default function HeaderService() {
  const serviceName = 'Etaten for store og små ting taten for store og små ting'
  const serviceLink = 'https://genrandom.com/cats/'

  const user: User = {
    name: 'Aksel Olsen',
    shortname: 'AO',
    lastLoggedIn: new Date('2025-09-19'),
  }

  const representing: Representing = {
    name: 'Joe & the Juice',
    shortname: 'JJ',
    orgNumber: '911738066',
  }

  const userMenu: UserMenuItem[] = [
    {
      title: 'Mine bookinger',
      iconName: 'heart',
      target: '#',
    },
    {
      title: 'Mine adresser',
      iconName: 'house-heart',
      target: '#',
    },
    {
      title: 'Innstillinger',
      iconName: 'cogwheel',
      target: () => {
        console.log('Innstillinger clicked')
      },
    },
  ]

  const linkAndButtonContent = (
    <>
      <PktLink href="https://www.oslo.kommune.no">Lenke</PktLink>
      <PktLink href="https://www.oslo.kommune.no">Lenke</PktLink>
      <PktButton skin="secondary">Knapp</PktButton>
    </>
  )

  return (
    <main className="page-main ">
      <h1>Service Header</h1>
      <p className="pkt-ingress"> default breakpoint: tablet-big (1024px ~)</p>
      <PktHeaderService
        serviceName="Service Name"
        serviceLink="#"
        compact={true}
        mobileBreakpoint={768}
        tabletBreakpoint={1280}
        hideLogo={true}
        position="relative"
        scrollBehavior="none"
      >
        {linkAndButtonContent}
      </PktHeaderService>

      <div style={{ margin: '2rem 0', border: '2px dashed #ccc', padding: '1rem 0' }}>
        <h2>Header height</h2>
        <h3 className="pkt-txt-16-medium">Standard</h3>
        <p>laptop (1280px ~): 104 px, tablet-up (1024px ~): 88 px, mobile (0px ~ 767px): 72 px</p>
        <PktHeaderService
          serviceName={serviceName}
          serviceLink={serviceLink}
          position="relative"
          scrollBehavior="none"
        />

        <h3 className="pkt-txt-16-medium" style={{ marginTop: '1.5rem' }}>
          Compact
        </h3>
        <p>laptop (1280px ~): 72 px, tablet-up (1024px ~): 64 px, mobile (0px ~ 767px): 64 px</p>
        <PktHeaderService
          serviceName={serviceName}
          logoLink={'https://oslo.kommune.no'}
          compact={true}
          mobileBreakpoint={1280}
          tabletBreakpoint={1600}
          position="relative"
          scrollBehavior="none"
        ></PktHeaderService>
      </div>

      <div style={{ margin: '2rem 0', border: '2px dashed #ccc', padding: '1rem 0' }}>
        <h2> Slot innhold </h2>
        <p>Header med lenker/knapper, og separat logout knapp.</p>
        <PktHeaderService
          serviceName="Etaten for store og små ting"
          serviceLink="https://www.gravferdsetaten.no"
          logOut={() => console.log('Logg ut')}
          logOutButtonPlacement="userMenu"
          user={user}
          userMenu={userMenu}
          position="relative"
          scrollBehavior="none"
        >
          {linkAndButtonContent}
        </PktHeaderService>
      </div>
      <div style={{ margin: '2rem 0', border: '2px dashed #ccc', padding: '1rem 0' }}>
        <h2> Søk</h2>
        <p>Header med søk, brukermeny, brukermeny og logout knapp (usermenu, header).</p>
        <PktHeaderService
          serviceName="Etaten for store og små ting"
          serviceLink="https://www.gravferdsetaten.no"
          user={user}
          logOutButtonPlacement="header"
          userMenu={userMenu}
          logOut={() => console.log('Logg ut')}
          showSearch={true}
          position="relative"
          scrollBehavior="none"
        ></PktHeaderService>
      </div>

      <div style={{ margin: '2rem 0', border: '2px dashed #ccc', padding: '1rem 0' }}>
        <h2> User menu (brukermeny)</h2>
        <p> Brukermeny med/uten lenker, med/uten bruker/representant, med/uten logg ut knapp</p>

        <h3 className="pkt-txt-16-medium" style={{ marginTop: '1.5rem' }}>
          Kort navn
        </h3>
        <p>Min bredde på bruker meny, lenker over to linjer</p>

        <PktHeaderService
          serviceName={serviceName}
          serviceLink={serviceLink}
          user={user}
          representing={representing}
          userMenu={userMenu}
          canChangeRepresentation={true}
          changeRepresentation={() => console.log('Endre organisasjon')}
          logOutButtonPlacement="userMenu"
          logOut={() => console.log('Logg ut')}
          position="relative"
          scrollBehavior="none"
        ></PktHeaderService>

        <h3 className="pkt-txt-16-medium" style={{ marginTop: '1.5rem' }}>
          Langt navn
        </h3>
        <p>Max bredde på brukernavn</p>
        <PktHeaderService
          serviceName={serviceName}
          serviceLink={serviceLink}
          user={{ ...user, name: 'Aksel Thao Karlsen Nguyen Mohammed Veldig langt navn' }}
          representing={{
            ...representing,
            name: 'Joe & the Juice Norge AS Joe & the Juice Norge AS Veldig langt navn',
          }}
          userMenu={userMenu}
          logOutButtonPlacement="userMenu"
          logOut={() => console.log('Logg ut')}
          position="relative"
          scrollBehavior="none"
        ></PktHeaderService>

        <h3 className="pkt-txt-16-medium" style={{ marginTop: '1.5rem' }}>
          Diverse props i brukermeny
        </h3>
        <p>Ingen lenker i brukermeny, overskrevet label</p>
        <PktHeaderService
          serviceName={serviceName}
          serviceLink={serviceLink}
          user={{ name: 'Aksel Web Oppdahl', shortname: 'AWO' }}
          representing={{
            name: 'The company of love and glitter',
            shortname: 'TCOLG',
            orgNumber: '123456789',
          }}
          logOutButtonPlacement="both"
          logOut={() => console.log('Logg ut')}
          position="relative"
          scrollBehavior="none"
        ></PktHeaderService>
      </div>

      <div style={{ margin: '2rem 0', border: '2px dashed #ccc', padding: '1rem 0' }}>
        <h2> ALL OF THE PROPS 😱</h2>
        <p> ALT VI HAR Å TILBY. PLS Punkters, never use it all at once. 😭</p>

        <h3 className="pkt-txt-16-medium" style={{ marginTop: '1.5rem' }}>
          Alle props
        </h3>
        <p>Custom mobile break point satt til: </p>

        <PktHeaderService
          serviceName={'Send hjelp'}
          serviceLink={serviceLink}
          compact={true}
          user={user}
          representing={representing}
          userMenu={userMenu}
          canChangeRepresentation={true}
          changeRepresentation={() => console.log('Endre organisasjon')}
          logOutButtonPlacement="both"
          logOut={() => console.log('Logg ut')}
          showSearch={true}
          position="relative"
          scrollBehavior="none"
        >
          {linkAndButtonContent}
        </PktHeaderService>
      </div>
      <div style={{ margin: '2rem 0', border: '2px dashed #ccc', padding: '1rem 0' }}>
        <h2> Alle props pluss langt avsender navn</h2>
        <p>UGLY BREAK at tablet (768px ~)</p>

        <PktHeaderService
          serviceName={serviceName}
          serviceLink="#"
          compact={true}
          mobileBreakpoint={768}
          tabletBreakpoint={1600}
          showSearch={true}
          logOutButtonPlacement="both"
          logOut={() => console.log('Logg ut')}
          user={user}
          position="relative"
          scrollBehavior="none"
        >
          {linkAndButtonContent}
        </PktHeaderService>
      </div>
    </main>
  )
}
